var g = Object.defineProperty;
var p = (r, e, s) => e in r ? g(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s;
var l = (r, e, s) => (p(r, typeof e != "symbol" ? e + "" : e, s), s);
var w = /* @__PURE__ */ ((r) => (r.GET = "get", r.POST = "post", r.PUT = "put", r.DELETE = "delete", r))(w || {});
class f extends Error {
  constructor() {
    super(...arguments);
    l(this, "status", -1);
    l(this, "params", null);
    l(this, "code", "UNKNOWN");
  }
}
class y {
  constructor(e, s = !1, t = !1) {
    l(this, "debug");
    l(this, "headers");
    l(this, "credentials");
    l(this, "handlers");
    l(this, "url");
    l(this, "suppressErrors");
    this.debug = t, this.headers = {}, this.handlers = [], this.credentials = "same-origin", this.suppressErrors = s, this.url = e;
  }
  async get(e, s = {}, t) {
    const i = Object.keys(s);
    return i.length && (e += "?", e += i.map(
      (a) => `${encodeURIComponent(a)}=${encodeURIComponent(s[a])}`
    ).join("&")), await this.standardRequest(
      e,
      "get",
      void 0,
      t
    );
  }
  async put(e, s, t) {
    return await this.standardRequest(
      e,
      "put",
      s,
      t
    );
  }
  async post(e, s, t) {
    return await this.standardRequest(
      e,
      "post",
      s,
      t
    );
  }
  async delete(e, s, t) {
    return await this.standardRequest(
      e,
      "delete",
      s,
      t
    );
  }
  async standardRequest(e, s, t, i = !1) {
    const a = { ...this.headers };
    if (!(t instanceof FormData))
      t = JSON.stringify(t);
    else {
      const d = Object.keys(a).filter(
        (n) => n.toLowerCase() === "content-type"
      );
      for (const n of d)
        delete a[n];
    }
    return await this.raw(
      `${this.url}${e}`,
      {
        headers: a,
        credentials: this.credentials,
        method: s,
        body: t
      },
      // @ts-expect-error
      i
    );
  }
  async raw(e, s, t = !1) {
    const i = t === !1 ? !1 : t || this.suppressErrors;
    this.debug && (console.log("request.raw", `${s.method} ${e}`), s.body && console.log("request.raw body", s.body));
    let a = null;
    try {
      a = await fetch(e, s);
    } catch (c) {
      this.debug && console.log("request.raw fetch_error", c);
      const o = c;
      if (o.code = "NETWORK", o.status = -1, this.callHandlers("error", o), i)
        return;
      throw o;
    }
    const d = await a.text();
    this.debug && (console.log("reqest.raw status", a.status), console.log("request.raw result", d));
    let n = null;
    try {
      n = JSON.parse(d);
    } catch (c) {
      this.debug && console.log("request.raw parse_error", c);
      const o = new f(d);
      if (o.status = a.status, this.callHandlers("error", o), i)
        return;
      throw o;
    }
    if (a.status >= 400) {
      let c = d;
      const o = n;
      n.message && (c = n.message);
      let u = null;
      o.params && (u = o.params);
      const h = new f(c);
      if (h.status = a.status, u && (h.params = u), n.code && (h.code = n.code), this.callHandlers("error", h), i)
        return;
      throw h;
    }
    return n;
  }
  on(e, s) {
    this.handlers.push({ event: e, cb: s });
  }
  off(e, s) {
    s ? this.handlers = this.handlers.filter(
      (t) => t.event !== e && t.cb !== s
    ) : this.handlers = this.handlers.filter((t) => t.event !== e);
  }
  callHandlers(e, s) {
    setTimeout(() => {
      this.handlers.filter((t) => t.event === e).forEach((t) => t.cb(s));
    }, 0);
  }
}
export {
  y as Req,
  w as ReqMethod
};
